export const shortISODateFormat = 'yyyy-MM-dd';
